import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setAdding(state, payload) {
    state.isAdding = payload;
  },
  setHandling(state, payload) {
    state.isHandling = payload;
  },
  setRefreshing(state, payload) {
    state.isRefreshing = payload;
  },
  setDetail(state, payload) {
    state.detail = payload;
  },
  setRoles(state, payload) {
    state.roles = payload;
  },
  setUsers(state, payload) {
    state.users = payload;
  },
  addUsers(state, payload) {
    state.users.push(...payload);
  },
  setPaging(state, payload) {
    state.paging = payload;
  },
};
